import Vue from 'vue';

export const LEVEL_CLICK = "LEVEL_CLICK";
export const LEVELGROUP_CLICK = "LEVELGROUP_CLICK";
export const UNIT_CLICK = "UNIT_CLICK";

export const EventBus = new Vue();
